import {Component, OnDestroy, OnInit} from '@angular/core';
import {UserNamespace} from '@namespaces/user.namespace';
import {ListItemsComponent} from '@abstract/list-items/list-items.component';
import {TechnicalDeviceElementsPagesService} from '../../services/elements/technical-device-elements-pages.service';
import {TechnicalDeviceDataService} from '../../services/technical-device-data.service';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {TechnicalDeviceNamespace} from '@namespaces/technical-device.namespace';
import SummaryInfo = TechnicalDeviceNamespace.SummaryInfo;
import {RoutesStorage} from '@helpers/routes.helper';

@Component({
    selector: 'app-conclusions',
    templateUrl: './conclusions.component.html',
    styleUrls: ['./conclusions.component.scss']
})
export class ConclusionsComponent extends ListItemsComponent<TechnicalDeviceElementsPagesService> implements OnInit, OnDestroy {

    public permissions = UserNamespace.Permission;

    public hasGroups = true;

    public newUrl: string;

    constructor(
        service: TechnicalDeviceElementsPagesService,
        private dataService: TechnicalDeviceDataService,
    ) {
        super(service);
    }

    ngOnInit() {
        super.ngOnInit();

        this.newUrl = RoutesStorage.TechnicalDeviceElement.new(this.dataService.deviceId);

        this.dataService.summaryInfo$.pipe(
            untilDestroyed(this)
        ).subscribe((info: SummaryInfo) => {
            this.hasGroups = Boolean(info && info.groupsCount);
        });
    }

    ngOnDestroy() {

    }
}
